import { Carousel, CarouselProps } from './carousel';
import withEvents from 'analytics/withEvents';


const withEventsCarouselComponent = withEvents<CarouselProps>((sendEvent) => ({
  eventViewPhotoScroll({ dir, image, index, total }) {
    sendEvent('property_view_photo_scroll', 'property', {
      event: {
        'direction_scrolled': dir,
        'image': {
          'description': image.description,
          'image_url': image.url,
          'isFloorPlanPhoto': Boolean(image.isFloorPlan),
        },
        'image_index': index,
        'image_source': 'gallery',
        'index_total': total,
      },
    });
  },
}))(Carousel);

export default withEventsCarouselComponent;
